import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["formRef"];
import React from 'react';
/**
 * The Form component renders a form element, but disables the default browser submit
 * behavior, which may include an unwanted full page refresh. Instead, the onSubmit
 * prop is called whenever a form is submitted.
 *
 * Note this component does not block submit on field validation errors. For that, use
 * the `FormWithValidation` component.
 */
export function Form(_ref) {
  var formRef = _ref.formRef,
    formProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("form", _extends({}, formProps, {
    ref: formRef,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      formProps.onSubmit && formProps.onSubmit(e);
    }
  }));
}